import PropTypes from 'prop-types';

import { StatusEnum } from 'constants/status';

// LoanActionResult.MersPreview's verdict — what running the real MERS action would do.
export const MersPreviewVerdict = {
  WOULD_SEND: 'WouldSend',
  WOULD_BE_REFUSED: 'WouldBeRefused',
  ALREADY_DONE: 'AlreadyDone',
  ALREADY_WITH_MERS: 'AlreadyWithMers',
  NOT_CONFIGURED: 'NotConfigured',
};

// The channel the real action would use (MersChannel in Lender.Optimus.Integrations).
const MersChannel = {
  XML: 'Xml',
  SFTP: 'Sftp',
};

const WOULD_SEND_PAYLOAD_TITLE = 'Exactly what would be sent';

// Only a WouldSend payload is what the action would send now; any other payload is what it would have sent.
const WOULD_HAVE_SENT_PAYLOAD_TITLE = 'What would have been sent';

// Each verdict's banner (colour and wording) and the title of its payload section.
export const MERS_PREVIEW_VERDICT_CONFIGS = {
  [MersPreviewVerdict.WOULD_SEND]: {
    variant: StatusEnum.INFO,
    title: 'This is what would be sent.',
    payloadTitle: WOULD_SEND_PAYLOAD_TITLE,
  },
  [MersPreviewVerdict.WOULD_BE_REFUSED]: {
    variant: StatusEnum.ERROR,
    title: 'This would be refused.',
    payloadTitle: WOULD_HAVE_SENT_PAYLOAD_TITLE,
  },
  [MersPreviewVerdict.ALREADY_DONE]: {
    variant: StatusEnum.WARNING,
    title: 'MERS already shows this done.',
    payloadTitle: WOULD_HAVE_SENT_PAYLOAD_TITLE,
  },
  [MersPreviewVerdict.ALREADY_WITH_MERS]: {
    variant: StatusEnum.WARNING,
    title: 'This is already with MERS.',
    payloadTitle: WOULD_HAVE_SENT_PAYLOAD_TITLE,
  },
  [MersPreviewVerdict.NOT_CONFIGURED]: {
    variant: StatusEnum.WARNING,
    title: 'MERS is not set up for this.',
    payloadTitle: WOULD_HAVE_SENT_PAYLOAD_TITLE,
  },
};

// A WouldSend preview that could not show its payload claims nothing in its title; the message says what happened.
export const WOULD_SEND_WITHOUT_PAYLOAD_TITLE = null;

// A verdict this screen does not know yet still shows its message.
export const UNKNOWN_VERDICT_CONFIG = {
  variant: StatusEnum.WARNING,
  title: null,
  payloadTitle: WOULD_HAVE_SENT_PAYLOAD_TITLE,
};

// The channel as people write it.
export const MERS_CHANNEL_LABELS = {
  [MersChannel.XML]: 'XML',
  [MersChannel.SFTP]: 'SFTP',
};

export const MERS_PREVIEW_TITLE_PREFIX = 'Preview — MERS';
export const NOTHING_SENT_SUBTITLE = 'Nothing has been sent to MERS.';
export const CONTEXT_SEPARATOR = ' · ';
export const ORG_ID_PREFIX = 'Org ID';

export const CLOSE_LABEL = 'Close';
export const COPY_PAYLOAD_LABEL = 'Copy payload';
export const PAYLOAD_COPIED_MESSAGE = 'Payload copied.';

export const MersPreviewFieldColumn = {
  LABEL: 'label',
  VALUE: 'value',
  NOTE: 'note',
};

export const EMPTY_FIELD_VALUE = '—';
export const EMPTY_PREVIEW_LIST = [];

// Before any preview has run there is nothing to show.
export const NO_PREVIEW = {};

// LoanActionResult.MersPreview, as the API returns it.
export const mersPreviewPropType = PropTypes.shape({
  type: PropTypes.string,
  operation: PropTypes.string,
  verdict: PropTypes.string,
  message: PropTypes.string,
  environment: PropTypes.string,
  channel: PropTypes.string,
  orgId: PropTypes.string,
  min: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string),
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      note: PropTypes.string,
    }),
  ),
  payload: PropTypes.string,
  payloadFormat: PropTypes.string,
});
